import WebService from './web-service';

export default WebService
export { WebService }
